class CartMiniController {
    /*@ngInject*/
    constructor($log, $rootScope, CartMiniService, CommonService) {
        $log.debug('CartMiniController initialized');
        this.$log = $log;
        this.cartMiniService = CartMiniService;
        this.commonService = CommonService;

        $rootScope.$on('addToCartSuccess', () => {
            this.cartMiniService.setItemsQuantity(this.cartMiniService.getItemsQuantity() + 1);
        });
        $rootScope.$on('personalizeRequestSuccess', () => {
            this.cartMiniService.setItemsQuantity(this.commonService.getPersonalizeRequestResponse().cartQuantity);
        });
    }

    getItemsQuantity() {
        return this.cartMiniService.getItemsQuantity();
    }
}

export default CartMiniController;
